import { BreadcrumbProvider } from "@/ui-components/ui/breadcrumb/breadcrumb-context";
import DynamicBreadcrumb from "@/ui-components/ui/breadcrumb/breadcrumb-url";
import GlobalSearch from "@/ui-components/ui/global-search";
import TopBar from "@/ui-components/utils/menu-items/top-bar";
import { ReactElement } from "react";

const DashboardOldRootComponent = ({ children }: { children: ReactElement }) => {
  return (
    <div className="flex flex-col h-full">
      <BreadcrumbProvider>
        <TopBar>
          <>
            <DynamicBreadcrumb />
            <GlobalSearch />
            <div className="flex-1"></div>
          </>
        </TopBar>
        <div className="flex grow">
          <div className="grow">{children}</div>
        </div>
      </BreadcrumbProvider>
    </div>
  );
};

export default DashboardOldRootComponent;
